import { render, staticRenderFns } from "./CriarPedidoPanel.vue?vue&type=template&id=57a2bab6&scoped=true&"
import script from "./CriarPedidoPanel.vue?vue&type=script&lang=js&"
export * from "./CriarPedidoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a2bab6",
  null
  
)

export default component.exports